export var CategoriesData = [
    {
        id: '6051a82566fc1b42617d6dc6',
        name: 'Memes',
        geniusName: 'Trending',
        targetFilters: [
            'Ethereum',
            'Optimism',
            'BNB Smart Chain (BEP20)',
            'Polygon',
            'Base',
            'Arbitrum',
            'Avalanche C-Chain',
            'Solana',
        ],
        tokens: [
            {
                contractAddress: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
                chainId: '56',
                name: 'Dogecoin',
                marketCap: 18282747657.70277,
            },
            {
                contractAddress: '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
                chainId: '1',
                name: 'Shiba Inu',
                marketCap: 10917026007.08481,
            },
            {
                contractAddress: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                chainId: '1',
                name: 'Pepe',
                marketCap: 4413151865.643783,
            },
            {
                contractAddress: 'EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm',
                chainId: '1399811149',
                name: 'dogwifhat',
                marketCap: 2642687594.223075,
            },
            {
                contractAddress: '0x1151CB3d861920e07a38e03eEAd12C32178567F6',
                chainId: '1',
                name: 'Bonk',
                marketCap: 1832950468.2279932,
            },
            {
                contractAddress: '0xcf0c122c6b73ff809c693db761e7baebe62b6a2e',
                chainId: '1',
                name: 'FLOKI',
                marketCap: 1448289552.026239,
            },
            {
                contractAddress: '7GCihgDB8fe6KNjn2MYtkzZcRjQy3t9GHdC8uHYmW2hr',
                chainId: '1399811149',
                name: 'Popcat (SOL)',
                marketCap: 1211831558.235186,
            },
            {
                contractAddress: '0x532f27101965dd16442e59d40670faf5ebb142e4',
                chainId: '8453',
                name: 'Brett (Based)',
                marketCap: 1044873994.8029717,
            },
            {
                contractAddress: '0x812ba41e071c7b7fa4ebcfb62df5f45f6fa853ee',
                chainId: '1',
                name: 'First Neiro On Ethereum',
                marketCap: 856551135.3517604,
            },
            {
                contractAddress: '0xaaeE1A9723aaDB7afA2810263653A34bA2C21C7a',
                chainId: '1',
                name: 'Mog Coin',
                marketCap: 811690847.1518551,
            },
            {
                contractAddress: 'MEW1gQWJ3nEXg2qgERiKu7FAFj79PHvQVREQUzScPP5',
                chainId: '1399811149',
                name: 'cat in a dogs world',
                marketCap: 754728841.8588624,
            },
            {
                contractAddress: '0xa35923162c49cf95e6bf26623385eb431ad920d3',
                chainId: '1',
                name: 'Turbo',
                marketCap: 716858806.8568375,
            },
            {
                contractAddress: '0xe0f63a424a4439cbe457d80e4f4b51ad25b2c56c',
                chainId: '1',
                name: 'SPX6900',
                marketCap: 625690103.75699,
            },
            {
                contractAddress: 'ukHH6c7mMyiWCf1b9pnWe25TSpkDDt3H5pQZgZ74J82',
                chainId: '1399811149',
                name: 'BOOK OF MEME',
                marketCap: 629556593.3811775,
            },
            {
                contractAddress: '0xac57de9c1a09fec648e93eb98875b212db0d460b',
                chainId: '1',
                name: 'Baby Doge Coin',
                marketCap: 444892229.3043199,
            },
            {
                contractAddress: '63LfDmNb3MQ8mw9MtZ2To9bEA2M71kZUUGq5tiJxcqj9',
                chainId: '1399811149',
                name: 'Gigachad',
                marketCap: 388688911.35120964,
            },
            {
                contractAddress: '0xb131f4a55907b10d1f0a50d8ab8fa09ec342cd74',
                chainId: '1',
                name: 'Memecoin',
                marketCap: 378730707.7543804,
            },
            {
                contractAddress: 'CzLSujWBLFsSjncfkh59rUFqvafWcY5tzedWJSuypump',
                chainId: '1399811149',
                name: 'Goatseus Maximus',
                marketCap: 322129034.24811953,
            },
            {
                contractAddress: '0x72e4f9f808c49a2a61de9c5896298920dc4eeea9',
                chainId: '1',
                name: 'HarryPotterObamaSonic10Inu (ERC-20)',
                marketCap: 265789792.6052813,
            },
            {
                contractAddress: '0x594DaaD7D77592a2b97b725A7AD59D7E188b5bFa',
                chainId: '1',
                name: 'Apu Apustaja',
                marketCap: 259356515.3183469,
            },
            {
                contractAddress: '0xa21af1050f7b26e0cff45ee51548254c41ed6b5c',
                chainId: '1',
                name: 'Osaka Protocol',
                marketCap: 242870587.46691573,
            },
            {
                contractAddress: '0x8ed97a637a790be1feff5e888d43629dc05408f6',
                chainId: '1',
                name: 'Non-Playable Coin',
                marketCap: 241549070.12681457,
            },
            {
                contractAddress: '5z3EqYQo9HiCEs3R84RCDMu2n7anpDMxRhdK8PSWmrRC',
                chainId: '1399811149',
                name: 'Ponke',
                marketCap: 230371424.7566045,
            },
            {
                contractAddress: '0x576e2BeD8F7b46D34016198911Cdf9886f78bea7',
                chainId: '1',
                name: 'MAGA',
                marketCap: 228824754.7450416,
            },
            {
                contractAddress: '0xA9E8aCf069C58aEc8825542845Fd754e41a9489A',
                chainId: '1',
                name: 'PepeCoin',
                marketCap: 228454371.00155732,
            },
            {
                contractAddress: '5mbK36SZ7J19An8jFochhQS4of8g6BwUjbeCSxBSoWdp',
                chainId: '1399811149',
                name: 'michi (SOL)',
                marketCap: 184853561.48217624,
            },
            {
                contractAddress: '0x6894CDe390a3f51155ea41Ed24a33A4827d3063D',
                chainId: '56',
                name: "Simon's Cat",
                marketCap: 178850663.96952406,
            },
            {
                contractAddress: '0x68bbed6a47194eff1cf514b50ea91895597fc91e',
                chainId: '1',
                name: 'ANDY (ETH)',
                marketCap: 159665494.47732636,
            },
            {
                contractAddress: '6ogzHhzdrQr9Pgv6hZ2MNze7UrzBMAFyBBWUYp1Fhitx',
                chainId: '1399811149',
                name: 'RETARDIO',
                marketCap: 144186449.51944432,
            },
            {
                contractAddress: '0x4ed4e862860bed51a9570b96d89af5e1b0efefed',
                chainId: '8453',
                name: 'Degen',
                marketCap: 123882782.24382764,
            },
            {
                contractAddress: '0x9ec02756a559700d8d9e79ece56809f7bcc5dc27',
                chainId: '56',
                name: 'WHY',
                marketCap: 117392206.28668372,
            },
            {
                contractAddress: '5LafQUrVco6o7KMz42eqVEJ9LW31StPyGjeeu5sKoMtA',
                chainId: '1399811149',
                name: 'Mumu the Bull (SOL)',
                marketCap: 117454898.26900895,
            },
            {
                contractAddress: 'HhJpBhRRn4g56VsyLuT8DL5Bv31HkXqsrahTTUCZeZg4',
                chainId: '1399811149',
                name: 'Myro',
                marketCap: 104832834.63189672,
            },
            {
                contractAddress: '0x420fca0121dc28039145009570975747295f2329',
                chainId: '43114',
                name: 'Coq Inu',
                marketCap: 103648289.47763278,
            },
            {
                contractAddress: '7BgBvyjrZX1YKz4oh9mjb8ZScatkkwb8DzFx7LoiVkM3',
                chainId: '1399811149',
                name: 'SLERF',
                marketCap: 99190362.22775342,
            },
            {
                contractAddress: '0xb9f599ce614Feb2e1BBe58F180F370D05b39344E',
                chainId: '1',
                name: 'PepeFork',
                marketCap: 95975033.3682094,
            },
            {
                contractAddress: '0xee2a03aa6dacf51c18679c516ad5283d8e7c2637',
                chainId: '1',
                name: 'Neiro Ethereum',
                marketCap: 95102104.84461537,
            },
            {
                contractAddress: '0x9813037ee2218799597d83D4a5B6F3b6778218d9',
                chainId: '1',
                name: 'Bone ShibaSwap',
                marketCap: 94081174.02609,
            },
            {
                contractAddress: '0x5026F006B85729a8b14553FAE6af249aD16c9aaB',
                chainId: '1',
                name: 'Wojak',
                marketCap: 91192187.37665671,
            },
            {
                contractAddress: '4Cnk9EPnW5ixfLZatCPJjDB1PUtcRpVVgTQukm9epump',
                chainId: '1399811149',
                name: 'Daddy Tate',
                marketCap: 90266998.21066771,
            },
            {
                contractAddress: '0xb90b2a35c65dbc466b04240097ca756ad2005295',
                chainId: '1',
                name: 'BOBO',
                marketCap: 85955213.52400514,
            },
            {
                contractAddress: 'ED5nyyWEzpPPiWimP8vYm7sD7TD3LAt3Q3gRTWHzPJBY',
                chainId: '1399811149',
                name: 'Moo Deng (moodengsol.com)',
                marketCap: 81828032.52667566,
            },
            {
                contractAddress: '0x6e79b51959cf968d87826592f46f819f92466615',
                chainId: '1',
                name: 'Hoppy',
                marketCap: 83377178.28516988,
            },
            {
                contractAddress: '0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3',
                chainId: '1',
                name: 'Dogelon Mars',
                marketCap: 78179796.43051702,
            },
            {
                contractAddress: 'WENWENvqqNya429ubCdR81ZmD69brwQaaBYY6p3LCpk',
                chainId: '1399811149',
                name: 'Wen',
                marketCap: 77827716.38475214,
            },
            {
                contractAddress: '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4',
                chainId: '8453',
                name: 'Toshi',
                marketCap: 73912168.69524333,
            },
            {
                contractAddress: '3S8qX1MsMqRbiwKg2cQyx7nis1oHMgaCuc9c4VfvVdPN',
                chainId: '1399811149',
                name: 'Mother Iggy',
                marketCap: 71128916.7262394,
            },
            {
                contractAddress: '0xd29da236dd4aac627346e1bba06a619e8c22d7c5',
                chainId: '1',
                name: 'MAGA',
                marketCap: 68714184.43772638,
            },
            {
                contractAddress: '0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b',
                chainId: '42161',
                name: 'ArbDoge AI',
                marketCap: 68870318.66445917,
            },
            {
                contractAddress: '0x3ffeea07a27fab7ad1df5297fa75e77a43cb5790',
                chainId: '1',
                name: 'PeiPei (ETH)',
                marketCap: 66516662.61851886,
            },
            {
                contractAddress: '25hAyBQfoDhfWx9ay6rarbgvWGwDdNqcHsXS3jQ3mTDJ',
                chainId: '1399811149',
                name: 'MANEKI',
                marketCap: 63724424.89827628,
            },
            {
                contractAddress: '0x12970e6868f88f6557b76120662c1b3e50a646bf',
                chainId: '1',
                name: 'Milady Meme Coin',
                marketCap: 62962110.88236479,
            },
            {
                contractAddress: '0x87266413e5b64DB72f11bB6795Ee976545DBAf43',
                chainId: '56',
                name: 'ShibaBitcoin',
                marketCap: 60524777.50156049,
            },
            {
                contractAddress: '0x4507cEf57C46789eF8d1a19EA45f4216bae2B528',
                chainId: '1',
                name: 'TokenFi',
                marketCap: 50322369.36542429,
            },
            {
                contractAddress: 'DPaQfq5sFnoqw2Sh9WMmmASFL9LNu6RdtDqwE1tab2tB',
                chainId: '1399811149',
                name: 'Skibidi Toilet',
                marketCap: 44246020.72691902,
            },
            {
                contractAddress: '0xb612bFC5cE2FB1337Bd29F5Af24ca85DbB181cE2',
                chainId: '1',
                name: 'Klaus',
                marketCap: 42933936.60835469,
            },
            {
                contractAddress: '0xaa95f26e30001251fb905d264Aa7b00eE9dF6C18',
                chainId: '1',
                name: 'Kendu Inu',
                marketCap: 40205177.1288262,
            },
            {
                contractAddress: '3B5wuUrMEi5yATD7on46hKfej3pfmd7t1RKgrsN3pump',
                chainId: '1399811149',
                name: 'Billy',
                marketCap: 39563051.92540456,
            },
            {
                contractAddress: '0xbbBBbBbBB7949dcC7d1539c91b81A5BF09E37bDB',
                chainId: '137',
                name: 'crow with knife',
                marketCap: 36582804.64615425,
            },
            {
                contractAddress: 'C2nneybCJP2i6mk6Nu6SfTcxoNXNLjngnzwDgje2eNrr',
                chainId: '1399811149',
                name: 'Jen-Hsun Huang',
                marketCap: 34305485.039319955,
            },
            {
                contractAddress: '0x8390a1da07e376ef7add4be859ba74fb83aa02d5',
                chainId: '1',
                name: 'Grok',
                marketCap: 33612020.47451417,
            },
            {
                contractAddress: '5ToDNkiBAK6k697RRyngTburU7yZNFZFx7jzsD1Uc7pK',
                chainId: '1399811149',
                name: 'Non-Playable Coin Solana',
                marketCap: 32360624.02320209,
            },
            {
                contractAddress: '8wXtPeU6557ETkp9WHFY1n1EcU6NxDvbAggHGsMYiHsB',
                chainId: '1399811149',
                name: 'GameStop',
                marketCap: 31419869.41540848,
            },
            {
                contractAddress: '0xD74b782E05AA25c50e7330Af541d46E18f36661C',
                chainId: '56',
                name: 'RichQUACK.com',
                marketCap: 31017798.315244935,
            },
            {
                contractAddress: '0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D',
                chainId: '1',
                name: 'Kishu Inu',
                marketCap: 30939811.342466068,
            },
            {
                contractAddress: 'FsA54yL49WKs7rWoGv9sUcbSGWCWV756jTD349e6H2yW',
                chainId: '1399811149',
                name: 'Koala AI',
                marketCap: 30185663.41148344,
            },
            {
                contractAddress: '0xba386A4Ca26B85FD057ab1Ef86e3DC7BdeB5ce70',
                chainId: '1',
                name: 'Jesus Coin',
                marketCap: 29982055.388291758,
            },
            {
                contractAddress: '0x1121AcC14c63f3C872BFcA497d10926A6098AAc5',
                chainId: '1',
                name: 'Department Of Government Efficiency (dogegov.com)',
                marketCap: 30398126.310282107,
            },
            {
                contractAddress: '0x27c70cd1946795b66be9d954418546998b546634',
                chainId: '1',
                name: 'Doge Killer',
                marketCap: 29495282.82376928,
            },
            {
                contractAddress: '9WPTUkh8fKuCnepRWoPYLH3aK9gSjPHFDenBq2X1Czdp',
                chainId: '1399811149',
                name: 'SelfieDogCoin',
                marketCap: 29357893.74775703,
            },
            {
                contractAddress: '0x7D8146cf21e8D7cbe46054e01588207b51198729',
                chainId: '1',
                name: 'BOB (ETH)',
                marketCap: 28647696.89730219,
            },
            {
                contractAddress: '0xf3c7cecf8cbc3066f9a87b310cebe198d00479ac',
                chainId: '1',
                name: 'FEED EVERY GORILLA',
                marketCap: 27236923.656564705,
            },
            {
                contractAddress: '7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU',
                chainId: '1399811149',
                name: 'Samoyedcoin',
                marketCap: 27201823.571644902,
            },
            {
                contractAddress: '0xBC45647eA894030a4E9801Ec03479739FA2485F0',
                chainId: '8453',
                name: 'Basenji',
                marketCap: 25829545.432010096,
            },
            {
                contractAddress: '6D7NaB2xsLd7cauWu1wKk6KBsJohJmP2qZH9GEfVi5Ui',
                chainId: '1399811149',
                name: 'Shark Cat',
                marketCap: 25331387.527539566,
            },
            {
                contractAddress: '8NNXWrWVctNw1UFeaBypffimTdcLCcD8XJzHvYsmgwpF',
                chainId: '1399811149',
                name: 'Brainlet',
                marketCap: 25330817.432324808,
            },
            {
                contractAddress: '0xB1a03EdA10342529bBF8EB700a06C60441fEf25d',
                chainId: '8453',
                name: 'Mr Miggles',
                marketCap: 23776686.784271833,
            },
            {
                contractAddress: '26KMQVgDUoB6rEfnJ51yAABWWJND8uMtpnQgsHQ64Udr',
                chainId: '1399811149',
                name: 'SAD HAMSTER',
                marketCap: 23206307.177259047,
            },
            {
                contractAddress: 'GtDZKAqvMZMnti46ZewMiXCa4oXF4bZxwQPoKzXPFxZn',
                chainId: '1399811149',
                name: 'nubcat',
                marketCap: 23004063.776613377,
            },
            {
                contractAddress: 'Faf89929Ni9fbg4gmVZTca7eW6NFg877Jqn6MizT3Gvw',
                chainId: '1399811149',
                name: 'LandWolf (SOL)',
                marketCap: 22276693.15613826,
            },
            {
                contractAddress: '0xc328a59E7321747aEBBc49FD28d1b32C1af8d3b2',
                chainId: '1',
                name: 'Philtoken',
                marketCap: 21352990.670040403,
            },
            {
                contractAddress: '0xf8ebf4849f1fa4faf0dff2106a173d3a6cb2eb3a',
                chainId: '1',
                name: 'Troll',
                marketCap: 21131725.074729558,
            },
            {
                contractAddress: '0x9e18d5bab2fa94a6a95f509ecb38f8f68322abd3',
                chainId: '1',
                name: 'Amaterasu Omikami',
                marketCap: 21059366.23090932,
            },
            {
                contractAddress: '0x051fb509e4a775fabd257611eea1efaed8f91359',
                chainId: '1',
                name: 'CateCoin',
                marketCap: 20759708.27252056,
            },
            {
                contractAddress: 'A3eME5CetyZPBoWbRUwY3tSe25S6tb18ba9ZPbWk9eFJ',
                chainId: '1399811149',
                name: 'Peng',
                marketCap: 20551378.863097344,
            },
            {
                contractAddress: '3xvLSHrLcM7246X1vu34cM9gNX741kQrzqj6T2HhLvXp',
                chainId: '1399811149',
                name: '8-Bit Coin',
                marketCap: 19662260.692352153,
            },
            {
                contractAddress: '0x2d5F3B0722aCd35fbb749cB936dfdd93247BBC95',
                chainId: '56',
                name: 'Baby BNB',
                marketCap: 18874077.843806297,
            },
            {
                contractAddress: '0xfF836A5821E69066c87E268bC51b849FaB94240C',
                chainId: '1',
                name: 'Real Smurf Cat',
                marketCap: 18799068.563643802,
            },
            {
                contractAddress: '0x89e8e084cc60e6988527f0904b4be71656e8bfa9',
                chainId: '1',
                name: 'Smog',
                marketCap: 17901765.53350246,
            },
            {
                contractAddress: '0xdE342A3E269056fc3305f9e315F4C40D917BA521',
                chainId: '1',
                name: 'Byte',
                marketCap: 17773996.39496507,
            },
            {
                contractAddress: '0xF0268c5F9aA95Baf5C25D646AAbB900Ac12F0800',
                chainId: '8453',
                name: 'RealGOAT',
                marketCap: 17458648.13563208,
            },
        ],
    },
    {
        id: '66a3201fdfec59177a0f3a35',
        name: 'Celebrity Memes',
        targetFilters: [
            'Ethereum',
            'Optimism',
            'BNB Smart Chain (BEP20)',
            'Polygon',
            'Base',
            'Arbitrum',
            'Avalanche C-Chain',
            'Solana',
        ],
        geniusName: 'Celebrities',
        tokens: [
            {
                contractAddress: '4Cnk9EPnW5ixfLZatCPJjDB1PUtcRpVVgTQukm9epump',
                chainId: '1399811149',
                name: 'Daddy Tate',
                marketCap: 90031322.01758665,
            },
            {
                contractAddress: '3S8qX1MsMqRbiwKg2cQyx7nis1oHMgaCuc9c4VfvVdPN',
                chainId: '1399811149',
                name: 'Mother Iggy',
                marketCap: 70863469.66938858,
            },
            {
                contractAddress: '0x482702745260ffd69fc19943f70cffe2cacd70e9',
                chainId: '1',
                name: 'Caitlyn Jenner (ETH)',
                marketCap: 113055.36187297448,
            },
            {
                contractAddress: '0x9c4cf40b5b5c3a58761683e65a87902130eb1b7c',
                chainId: '1',
                name: 'Tate Stop',
                marketCap: 11883.993474531953,
            },
            {
                contractAddress: 'EqGMz1o1KiBs1wtotR4rnDADEHvUu39Emv46ZjBEpump',
                chainId: '1399811149',
                name: 'Abella Danger',
                marketCap: 0,
            },
            {
                contractAddress: '2fUFhZyd47Mapv9wcfXh5gnQwFXtqcYu9xAN4THBpump',
                chainId: '1399811149',
                name: 'Real Nigger Tate',
                marketCap: 0,
            },
            {
                contractAddress: '9vrGUHwsC8LyLjQoh3zJb9S53x7A88u49La63qPB6F5t',
                chainId: '1399811149',
                name: 'lilpump',
                marketCap: 0,
            },
            {
                contractAddress: '8NH3AfwkizHmbVd83SSxc2YbsFmFL4m2BeepvL6upump',
                chainId: '1399811149',
                name: 'TOP G',
                marketCap: 0,
            },
            {
                contractAddress: '8vCAUbxejdtaxn6jnX5uaQTyTZLmXALg9u1bvFCAjtx7',
                chainId: '1399811149',
                name: 'Zack Morris',
                marketCap: 0,
            },
            {
                contractAddress: '9n8b1EXLCA8Z22mf7pjLKVNzuQgGbyPfLrmFQvEcHeSU',
                chainId: '1399811149',
                name: 'Waka Flocka',
                marketCap: 0,
            },
            {
                contractAddress: 'HRw8mqK8N3ASKFKJGMJpy4FodwR3GKvCFKPDQNqUNuEP',
                chainId: '1399811149',
                name: 'TrumpCoin',
                marketCap: 0,
            },
        ],
    },
    {
        id: '664716e98c23b0279034a5ed',
        name: 'Political Memes',
        geniusName: 'Politics',
        targetFilters: [
            'Ethereum',
            'Optimism',
            'BNB Smart Chain (BEP20)',
            'Polygon',
            'Base',
            'Arbitrum',
            'Avalanche C-Chain',
            'Solana',
        ],
        tokens: [
            {
                contractAddress: '0x7a58c0be72be218b41c608b7fe7c5bb630736c71',
                chainId: '1',
                name: 'ConstitutionDAO',
                marketCap: 428897702.3653397,
            },
            {
                contractAddress: '0x576e2BeD8F7b46D34016198911Cdf9886f78bea7',
                chainId: '1',
                name: 'MAGA',
                marketCap: 228398853.8997942,
            },
            {
                contractAddress: '0xd29da236dd4aac627346e1bba06a619e8c22d7c5',
                chainId: '1',
                name: 'MAGA',
                marketCap: 68931249.36051817,
            },
            {
                contractAddress: '0x7039cd6D7966672F194E8139074C3D5c4e6DCf65',
                chainId: '1',
                name: 'Super Trump Coin',
                marketCap: 15442043.721610144,
            },
            {
                contractAddress: '0x9EBb0895bD9C7C9dFAB0d8d877c66bA613Ac98Ea',
                chainId: '1',
                name: 'MAGA AGAIN',
                marketCap: 5336769.2133973995,
            },
            {
                contractAddress: '0xE66fD34c0f8726a5eb97f6d45C5A5Df4D57d39Fc',
                chainId: '56',
                name: 'Baby Trump (BSC)',
                marketCap: 2491710.6232052906,
            },
            {
                contractAddress: '0x766d2fcECe1E3eeF32aae8711ab886eE95fd5B2A',
                chainId: '1',
                name: 'MAGA VP',
                marketCap: 2378305.577992861,
            },
            {
                contractAddress: '0xD9eA93A38D1771C870128f9134D4622d331C04C8',
                chainId: '8453',
                name: 'Make America Based Again',
                marketCap: 1742265.4830959472,
            },
            {
                contractAddress: '0x2077D81d0c5258230D5a195233941547cB5f0989',
                chainId: '1',
                name: 'Trog',
                marketCap: 1630232.3344947253,
            },
            {
                contractAddress: '0x354c8cda7e3b737d360513a0dc5abcee8ee1cea3',
                chainId: '1',
                name: 'BABYTRUMP',
                marketCap: 1028925.3479098406,
            },
            {
                contractAddress: '0x426a688eE72811773eB64F5717A32981B56F10c1',
                chainId: '1',
                name: 'AMC',
                marketCap: 789687.5643553861,
            },
            {
                contractAddress: 'Gp5PYbvVkF5LqqwwPP1UazFExvnnUekjqZG7x9vkpump',
                chainId: '1399811149',
                name: 'DADDY TRUMP',
                marketCap: 114543.54826857212,
            },
            {
                contractAddress: '7mR9wrdgdjRgLmbA1nm21NReZSNkkJvhX6dNkk4cmkVC',
                chainId: '1399811149',
                name: 'JD Vance',
                marketCap: 0,
            },
            {
                contractAddress: '0x8802269d1283cdb2a5a329649e5cb4cdcee91ab6',
                chainId: '1',
                name: 'FIGHT TO MAGA',
                marketCap: 0,
            },
            {
                contractAddress: '0x9326c50e4c4754943a2fcd02268066eb86d53837',
                chainId: '1',
                name: 'USETH',
                marketCap: 0,
            },
            {
                contractAddress: '0x02e79d42C3297Cd4154A1b52B4a3b27Cd75762F1',
                chainId: '1',
                name: 'FIGHT FOR THE PEOPLE',
                marketCap: 0,
            },
            {
                contractAddress: '0x9b465aaB9e8F325418F222C37de474b1bD38ded2',
                chainId: '1',
                name: 'JD Vance',
                marketCap: 0,
            },
            {
                contractAddress: '0x81FcC294d91bd8FFC8a822d7df0e2fD2f8526c39',
                chainId: '1',
                name: 'Department Of Government Efficiency (DOGE)',
                marketCap: 0,
            },
            {
                contractAddress: '0xb2E0241B2385b4de5A7bE482051C5b0Da5622E12',
                chainId: '1',
                name: 'President Trump',
                marketCap: null,
            },
            {
                contractAddress: '0x4a67b2F73337D2A4f7d3084d9A117e464E55bed0',
                chainId: '56',
                name: 'CRAZY TRUMP',
                marketCap: 0,
            },
            {
                contractAddress: '0x9f4aC5eA89B1623E35328904D7D61B08B55dAA50',
                chainId: '1',
                name: 'Make America Great Once Again',
                marketCap: 0,
            },
            {
                contractAddress: '8m9fjYycXAFva1kScttQgsESVZT7yELhjZASqfHBuMa5',
                chainId: '1399811149',
                name: 'Alux Jownes',
                marketCap: 0,
            },
            {
                contractAddress: '0xccdF812aa7cdee4fF7cb89546d7f1718bb8d46E1',
                chainId: '56',
                name: 'TRUMP AI',
                marketCap: 0,
            },
            {
                contractAddress: '0x43FD9De06bb69aD771556E171f960A91c42D2955',
                chainId: '1',
                name: 'Bullish Trump Coin',
                marketCap: 0,
            },
            {
                contractAddress: '0xC1b75f11D319A5F1b676073Daa1f5dcDF0163f0D',
                chainId: '56',
                name: 'TRUMP MAGA SUPER',
                marketCap: 0,
            },
            {
                contractAddress: '0x70c0b83501A3989d4F8A8693581BB7010194ABB5',
                chainId: '1',
                name: 'Trump Harris Debate',
                marketCap: null,
            },
            {
                contractAddress: '0x63989348ebe7590b8863c5a242f7ee01efcca0c7',
                chainId: '1',
                name: 'TRUMPAMANIA',
                marketCap: 0,
            },
            {
                contractAddress: '0x9361adf2b72f413d96f81ff40d794b47ce13b331',
                chainId: '1',
                name: 'BARRON',
                marketCap: 0,
            },
            {
                contractAddress: '0xae0FE8474CF5b1B412b3E4327A1c535ea12b77b7',
                chainId: '1',
                name: 'MAGA CAT',
                marketCap: 0,
            },
            {
                contractAddress: '0xCaB66bc319C96A2921Caed30E990b20F2322357e',
                chainId: '1',
                name: 'Simpson Trump',
                marketCap: 0,
            },
            {
                contractAddress: '0x880226cbcce551eeafd18c9a9e883c85811b82fc',
                chainId: '1',
                name: 'Trump2024',
                marketCap: 0,
            },
            {
                contractAddress: '0x0FE13FfE64B28a172c58505e24c0c111d149BD47',
                chainId: '1',
                name: 'Trump Pepe',
                marketCap: 0,
            },
            {
                contractAddress: '54y5AoY8KPxT5puB5Jie3ubX9Pz2g1UsNf4Ci8BjHvBe',
                chainId: '1399811149',
                name: 'Kamala Harris (kamalaharris2024.club)',
                marketCap: 0,
            },
            {
                contractAddress: '0x155788dd4b3ccd955a5b2d461c7d6504f83f71fa',
                chainId: '1',
                name: 'Kamala Harris (kamalaharristoken.xyz)',
                marketCap: 0,
            },
            {
                contractAddress: '3uRtURdYNfQ73BpQQuvb2j4eiPghW2azpNk2kL7GqMoB',
                chainId: '1399811149',
                name: 'World Liberty Financial (wlfi.site)',
                marketCap: 0,
            },
            {
                contractAddress: '2Xn4cBcrksaBMMxw8EbwuxY7iG8HUiZx1XEiCXQsGeSo',
                chainId: '1399811149',
                name: 'MAGA PEPE (SOL)',
                marketCap: 0,
            },
            {
                contractAddress: '3biDtnRND6bw8cLpSA6CNa8ewmsarTmuYwb1EVHmCXFC',
                chainId: '1399811149',
                name: 'Kamala Harris (kamalaharriscoin.com)',
                marketCap: 0,
            },
            // {
            //   contractAddress: '0x1Aca0c3CC90197c25D49591F35a66C897eA79E94',
            //   chainId: '8453',
            //   name: 'Krypto Harris (kryptoharris.shop)',
            //   marketCap: 0,
            // },
            {
                contractAddress: '2tvQMBiB4aoxsXhgAPWSUpE1Cas5eSU3bNWa6p6Rpump',
                chainId: '1399811149',
                name: 'KRAZY KAMALA',
                marketCap: 0,
            },
            {
                contractAddress: '0x2d570b062872ee7f459e8283c14be977289396bf',
                chainId: '8453',
                name: 'Giga Trump',
                marketCap: 0,
            },
            {
                contractAddress: '0x91F322e0D0bd688ACd511a789431a2b672A28013',
                chainId: '1',
                name: 'Fist Trump Pump',
                marketCap: 0,
            },
            {
                contractAddress: '0x9128770751A6D810a1F63752570257a775606dE6',
                chainId: '1',
                name: 'Book of Donald Trump',
                marketCap: 0,
            },
            {
                contractAddress: '3PPnF2QxVTm6TkxUT597ky549S2jt13YpqzW6U1D7kv3',
                chainId: '1399811149',
                name: 'PEGA',
                marketCap: 0,
            },
            {
                contractAddress: '0x0b6d588275bd85459Fadae832EFe860CC1F5d69E',
                chainId: '1',
                name: 'Department Of Government Efficiency (getdge.org)',
                marketCap: 0,
            },
            {
                contractAddress: '0x2b640A99991dea2916205ECdc9F9c58F80017ed8',
                chainId: '1',
                name: 'HARRIS (kamala.vip)',
                marketCap: 0,
            },
            {
                contractAddress: '7D7BRcBYepfi77vxySapmeqRNN1wsBBxnFPJGbH5pump',
                chainId: '1399811149',
                name: 'Dark MAGA',
                marketCap: 0,
            },
            {
                contractAddress: '0x943aF17C37207c9D7a27D12cb5055542A0b7aFa8',
                chainId: '1',
                name: 'ULTRA MAGA',
                marketCap: 0,
            },
            {
                contractAddress: 'GFNQHAAo1j4cQ1YndybxBKNiXzCLMk69bGDADCVFpump',
                chainId: '1399811149',
                name: 'KAMALAMA',
                marketCap: 0,
            },
            {
                contractAddress: '9Vv199SR7VKVqbJmM5LoT26ZtC9bzrmqqxE3b4dfrubX',
                chainId: '1399811149',
                name: 'Donald Pump',
                marketCap: 0,
            },
            {
                contractAddress: '2ASuSb6GAfjtj6gjX9hUk8hinuG1jLAMv5YaPnrhM8tB',
                chainId: '1399811149',
                name: 'Harris V Trump',
                marketCap: 0,
            },
            {
                contractAddress: '0x400bc4f1ee114537b4fec3b08810acfe117e7746',
                chainId: '1',
                name: 'JOE',
                marketCap: 0,
            },
            {
                contractAddress: '4pFEDnyi2PJtQrTuvpKg6wVB15N8qWPS7HBWxGMjEpcS',
                chainId: '1399811149',
                name: 'Donald Trump (dont.cash)',
                marketCap: 0,
            },
            {
                contractAddress: 'HBC9g8R5MHoBsZnSx194LR6e32f5FfPfn5DdayFmAJ4b',
                chainId: '1399811149',
                name: 'SolTrump',
                marketCap: null,
            },
            {
                contractAddress: '0xfE3DDeDde73809862d0104218c81dD8c478fA9d3',
                chainId: '56',
                name: 'TRUMP MAGA PRESIDENT',
                marketCap: 0,
            },
            {
                contractAddress: '8Sk1mazEDN1L6P6E9di4Xgza3icJw4Za9KUKqnUNEQrM',
                chainId: '1399811149',
                name: 'Kumala Herris',
                marketCap: 0,
            },
            {
                contractAddress: 'fhv6KL6hxetS1tiqybE8BQusucbPAhH73fpoKowWFA3',
                chainId: '1399811149',
                name: 'MAGA',
                marketCap: 0,
            },
            {
                contractAddress: 'D7pvtXoPvD7bQyWwK1s9E1Mf6ZrsBHLvC9ewK45cYF1m',
                chainId: '1399811149',
                name: 'Larry',
                marketCap: null,
            },
            {
                contractAddress: '0x91221a69a30c84a4f89c66a3475e36368de6131f',
                chainId: '1',
                name: 'Kamala (harris.cool)',
                marketCap: 0,
            },
            {
                contractAddress: '0x968496Dd59EFc1Caa11e94FDA99eA67Db7be5cd9',
                chainId: '1',
                name: 'TrumpChain',
                marketCap: 0,
            },
            {
                contractAddress: '0xE68F1cb52659f256Fee05Fd088D588908A6e85A1',
                chainId: '1',
                name: 'Save America',
                marketCap: 0,
            },
            {
                contractAddress: 'FYzAWUYqmu8kFzERPKkTgVYd4BSbedMjVhYPyLPdpump',
                chainId: '1399811149',
                name: 'Coconut',
                marketCap: 0,
            },
            {
                contractAddress: '0x1f70300bce8c2302780bd0a153ebb75b8ca7efcb',
                chainId: '1',
                name: 'Mini Donald',
                marketCap: 0,
            },
            {
                contractAddress: '0x05f226755b11cB3666340551EbBAa615CDFEFdD6',
                chainId: '1',
                name: 'TRUMP MEME (trumpmeme.net)',
                marketCap: 0,
            },
            {
                contractAddress: 'GtNk9X1F4NVQc44sRAUa2G2X9f934XoQs82m6yyzuNjn',
                chainId: '1399811149',
                name: 'BABYTRUMP',
                marketCap: null,
            },
            {
                contractAddress: '0x2f5a86aa0a0f6e6d2d48664866e7ce05a1335ce0',
                chainId: '1',
                name: 'Laffin Kamala',
                marketCap: null,
            },
            {
                contractAddress: 'HRw8mqK8N3ASKFKJGMJpy4FodwR3GKvCFKPDQNqUNuEP',
                chainId: '1399811149',
                name: 'TrumpCoin',
                marketCap: 0,
            },
            {
                contractAddress: '0x07040971246a73ebda9cf29ea1306bb47c7c4e76',
                chainId: '1',
                name: 'American pepe',
                marketCap: 0,
            },
            {
                contractAddress: 'KMnDBXcPXoz6oMJW5XG4tXdwSWpmWEP2RQM1Uujpump',
                chainId: '1399811149',
                name: 'FIGHT',
                marketCap: 0,
            },
            {
                contractAddress: '0x225e5b78f289c6d7d7757ad2b9d23b6ab31a5eea',
                chainId: '1',
                name: 'MAGA Trump',
                marketCap: 0,
            },
            {
                contractAddress: 'FTyr4aoR52GY5EWGuxSzEAY6szaYKzi3WAmHmeYppump',
                chainId: '1399811149',
                name: 'Kamala Harris (kamaharris.fun)',
                marketCap: 0,
            },
            {
                contractAddress: '0x683A4ac99E65200921f556A19dADf4b0214B5938',
                chainId: '1',
                name: 'Maga Pepe',
                marketCap: 0,
            },
            {
                contractAddress: '0x7E744BBB1a49A44dfCC795014a4BA618E418FbBE',
                chainId: '1',
                name: 'Maganomics',
                marketCap: 0,
            },
            {
                contractAddress: 'HnKkzR1YtFbUUxM6g3iVRS2RY68KHhGV7bNdfF1GCsJB',
                chainId: '1399811149',
                name: 'Kamala Horris',
                marketCap: 0,
            },
            {
                contractAddress: 'GfkfESc5A4EkxCGWsymNY4ZfkCDdvtB7ajCybLfYL1Qq',
                chainId: '1399811149',
                name: 'Alickshundra Occasional-Cortex',
                marketCap: 0,
            },
            {
                contractAddress: '4gBDhgCqTtzyJocskewXARgcLoAfSxkmmoUwwfhbpump',
                chainId: '1399811149',
                name: 'Chuan Pu',
                marketCap: 0,
            },
            {
                contractAddress: '0x00380d12a12acf6f47481e8ca8be777931395200',
                chainId: '1',
                name: 'Republican',
                marketCap: 0,
            },
            {
                contractAddress: '9EYScpiysGnEimnQPzazr7Jn9GVfxFYzgTEj85hV9L6U',
                chainId: '1399811149',
                name: 'tooker kurlson',
                marketCap: 0,
            },
            {
                contractAddress: '0XB8A155F5B7BBBEFB980E1F8550DD88318D3610E7',
                chainId: '1',
                name: 'Take America Back',
                marketCap: 0,
            },
            {
                contractAddress: '0x03dCee0d21ab39614c768DAb67BFC33B0Fc0A047',
                chainId: '1',
                name: 'MAGA: Fight for Trump',
                marketCap: 0,
            },
            {
                contractAddress: '0x2e1d332893Dc16124194E598a29866D2d5e8786b',
                chainId: '8453',
                name: 'MAGA',
                marketCap: 0,
            },
            {
                contractAddress: '0xAed18826655bF9167A377C8647132A937d6a4F36',
                chainId: '1',
                name: 'THE BIG DEBATE',
                marketCap: null,
            },
            {
                contractAddress: '0x6135177a17e02658df99a07a2841464deb5b8589',
                chainId: '1',
                name: 'FEAR NOT',
                marketCap: 0,
            },
            {
                contractAddress: '0xa2b904BeE594ee6e573E358f9c58bcCe9F0492c1',
                chainId: '1',
                name: 'Simpson Harris',
                marketCap: 0,
            },
            {
                contractAddress: '4h8LjZWUfUQVgbEZ29UzTuGXNW6rwrJis78ZU66ekkPV',
                chainId: '1399811149',
                name: 'Donald Trump',
                marketCap: 0,
            },
            {
                contractAddress: 'Bk6xRfMDXmcBXFFLQxQEqn2CNsthKcG7gQQyn4SyZxDj',
                chainId: '1399811149',
                name: 'Kamala Harris (kamalaharristoken.net)',
                marketCap: 0,
            },
            {
                contractAddress: '4Y5VtnjBVKMsnauJf8LmwaZYUfEyVG4z9C9nsGiXij8J',
                chainId: '1399811149',
                name: 'Magawincat',
                marketCap: 0,
            },
            {
                contractAddress: 'BqhNdGtS1Nqtzi2MvZ7G8NN1vRuHZ12UpHGJKe71e1JT',
                chainId: '1399811149',
                name: 'MoonTrump',
                marketCap: 0,
            },
            {
                contractAddress: '0x214dD1B5cBE543D4189Ab39832F1BC1eEDEBb1d3',
                chainId: '43114',
                name: 'Junior',
                marketCap: 0,
            },
            {
                contractAddress: '0x3121054687ddad7a49a9840fd4efcef1133747b4',
                chainId: '1',
                name: 'TrumpWifBiden',
                marketCap: null,
            },
            {
                contractAddress: 'TrumptpNNBEgVjDc8bnemRTNYZKhdsst9ujNAnTSHqp',
                chainId: '1399811149',
                name: 'Maek Amuruca Graet Agun',
                marketCap: 0,
            },
            {
                contractAddress: '0xb71bdc7014f3740d0267d41d632cab8371f8ba3c',
                chainId: '1',
                name: 'MILEI',
                marketCap: null,
            },
            {
                contractAddress: '0x441ec6748c51c19c93ce14439714b5401d6c3ded',
                chainId: '1',
                name: 'Pepe Trump',
                marketCap: 0,
            },
            {
                contractAddress: '0x52828b8a0109E1477bF9056A0918F153f9AEa3C6',
                chainId: '1',
                name: 'TRUMP',
                marketCap: 0,
            },
            {
                contractAddress: '0xb292b9281852AeFC47C58f5b7ec2D90C59035aD4',
                chainId: '56',
                name: 'MAGA',
                marketCap: 0,
            },
            {
                contractAddress: '0x1a11ea9d61588d756d9f1014c3cf0d226aedd279',
                chainId: '1',
                name: 'MILEI Token',
                marketCap: 0,
            },
            {
                contractAddress: 'ALe5WhLpdcg3qVcFiAEBor2PALFa5hwfCc55SccsxSiz',
                chainId: '1399811149',
                name: 'MAGA (Solana)',
                marketCap: 0,
            },
            {
                contractAddress: '0xc81688968Bd1E8Da313B8F2936852eC4307Cd17f',
                chainId: '56',
                name: 'PEPE',
                marketCap: 0,
            },
            {
                contractAddress: '0xbcd29da38b66e2b7855c92080ebe82330ed2012a',
                chainId: '1',
                name: 'BIDEN 2024',
                marketCap: null,
            },
            {
                contractAddress: '0x25b91b317cb95232d49c829e555c2fe695598ff7',
                chainId: '1',
                name: 'MAGA 2.0',
                marketCap: null,
            },
            {
                contractAddress: '0x5a446b57431c94Bd931c4e876Ca227bBe6553f6d',
                chainId: '1',
                name: 'MAGA',
                marketCap: 0,
            },
        ],
    },
    {
        id: '65c06eba1736b10877f3f55d',
        name: 'Cat-Themed',
        geniusName: 'Cats',
        targetFilters: [
            'Ethereum',
            'Optimism',
            'BNB Smart Chain (BEP20)',
            'Polygon',
            'Base',
            'Arbitrum',
            'Avalanche C-Chain',
            'Solana',
        ],
        tokens: [
            {
                contractAddress: '7GCihgDB8fe6KNjn2MYtkzZcRjQy3t9GHdC8uHYmW2hr',
                chainId: '1399811149',
                name: 'Popcat (SOL)',
                marketCap: 1207306992.4655588,
            },
            {
                contractAddress: '0xaaeE1A9723aaDB7afA2810263653A34bA2C21C7a',
                chainId: '1',
                name: 'Mog Coin',
                marketCap: 808046711.4156542,
            },
            {
                contractAddress: 'MEW1gQWJ3nEXg2qgERiKu7FAFj79PHvQVREQUzScPP5',
                chainId: '1399811149',
                name: 'cat in a dogs world',
                marketCap: 756054453.8605397,
            },
            {
                contractAddress: '5mbK36SZ7J19An8jFochhQS4of8g6BwUjbeCSxBSoWdp',
                chainId: '1399811149',
                name: 'michi (SOL)',
                marketCap: 184966068.7116811,
            },
            {
                contractAddress: '0x6894CDe390a3f51155ea41Ed24a33A4827d3063D',
                chainId: '56',
                name: "Simon's Cat",
                marketCap: 178619506.28125313,
            },
            {
                contractAddress: 'WENWENvqqNya429ubCdR81ZmD69brwQaaBYY6p3LCpk',
                chainId: '1399811149',
                name: 'Wen',
                marketCap: 77576552.91165976,
            },
            {
                contractAddress: '25hAyBQfoDhfWx9ay6rarbgvWGwDdNqcHsXS3jQ3mTDJ',
                chainId: '1399811149',
                name: 'MANEKI',
                marketCap: 63445906.74836979,
            },
            {
                contractAddress: '6D7NaB2xsLd7cauWu1wKk6KBsJohJmP2qZH9GEfVi5Ui',
                chainId: '1399811149',
                name: 'Shark Cat',
                marketCap: 25514754.477345668,
            },
            {
                contractAddress: '0xB1a03EdA10342529bBF8EB700a06C60441fEf25d',
                chainId: '8453',
                name: 'Mr Miggles',
                marketCap: 23807319.140687853,
            },
            {
                contractAddress: 'GtDZKAqvMZMnti46ZewMiXCa4oXF4bZxwQPoKzXPFxZn',
                chainId: '1399811149',
                name: 'nubcat',
                marketCap: 22917546.87263349,
            },
            {
                contractAddress: '0x051fb509e4a775fabd257611eea1efaed8f91359',
                chainId: '1',
                name: 'CateCoin',
                marketCap: 20700512.648128465,
            },
            {
                contractAddress: '0xfF836A5821E69066c87E268bC51b849FaB94240C',
                chainId: '1',
                name: 'Real Smurf Cat',
                marketCap: 18985414.830194782,
            },
            {
                contractAddress: '7atgF8KQo4wJrD5ATGX7t1V2zVvykPJbFfNeVf1icFv1',
                chainId: '1399811149',
                name: 'catwifhat',
                marketCap: 14115608.484199757,
            },
            {
                contractAddress: '0x03049b395147713ae53c0617093675b4b86dde78',
                chainId: '1',
                name: 'BobaCat',
                marketCap: 13607521.08005086,
            },
            {
                contractAddress: '0x59f4f336bf3d0c49dbfba4a74ebd2a6ace40539a',
                chainId: '1',
                name: 'CatCoin',
                marketCap: 12600540.2365449,
            },
            {
                contractAddress: 'GinNabffZL4fUj9Vactxha74GDAW8kDPGaHqMtMzps2f',
                chainId: '1399811149',
                name: 'Ginnan The Cat',
                marketCap: 12506865.360634426,
            },
            {
                contractAddress: 'HLptm5e6rTgh4EKgDpYFrnRHbjpkMyVdEeREEa2G7rf9',
                chainId: '1399811149',
                name: 'DUKO',
                marketCap: 12315263.135377498,
            },
            {
                contractAddress: '8doS8nzmgVZEaACxALkbK5fZtw4UuoRp4Yt8NEaXfDMb',
                chainId: '1399811149',
                name: "Waffles Davincij15's Cat",
                marketCap: 11751802.083880391,
            },
            {
                contractAddress: '0xf6e932ca12afa26665dc4dde7e27be02a7c02e50',
                chainId: '8453',
                name: 'Mochi (New)',
                marketCap: 9283653.32737185,
            },
            {
                contractAddress: '0x38F9bf9dCe51833Ec7f03C9dC218197999999999',
                chainId: '1',
                name: 'Nya',
                marketCap: 8544631.417727698,
            },
            {
                contractAddress: '0xeAA63125dd63f10874F99CdBbb18410e7Fc79dD3',
                chainId: '1',
                name: 'Hemule',
                marketCap: 8389799.037690425,
            },
            {
                contractAddress: '0x0DceE5F694E492F0DD842a7FBE5BEd4C6E4665a6',
                chainId: '1',
                name: 'Catboy',
                marketCap: 5303852.649215392,
            },
            {
                contractAddress: '0xbdf5bafee1291eec45ae3aadac89be8152d4e673',
                chainId: '56',
                name: 'CATAMOTO',
                marketCap: 4635756.593867972,
            },
            {
                contractAddress: '0xa00453052A36D43A99Ac1ca145DFe4A952cA33B8',
                chainId: '1',
                name: 'Cate',
                marketCap: 3525695.8289763285,
            },
            {
                contractAddress: 'FvER7SsvY5GqAMawf7Qfb5MnUUmDdbPNPg4nCa4zHoLw',
                chainId: '1399811149',
                name: 'The First Youtube Cat',
                marketCap: 3173322.798362517,
            },
            {
                contractAddress: '0x76B560b628F74BF192bE09F0449abef8e456BE79',
                chainId: '56',
                name: 'BabyCate',
                marketCap: 3049987.6713514384,
            },
            {
                contractAddress: '0x7777cec341e7434126864195adef9b05dcc3489c',
                chainId: '1',
                name: 'Onigiri',
                marketCap: 1360067.8363228808,
            },
            {
                contractAddress: 'E99fN4tCRb1tQphXK1DU7prXji6hMzxETyPNJro19Fwz',
                chainId: '1399811149',
                name: 'CatSolHat',
                marketCap: 821432.7272015266,
            },
            {
                contractAddress: '0x8ad25b0083c9879942a64f00f20a70d3278f6187',
                chainId: '43114',
                name: 'MeowCat',
                marketCap: 736521.9989174573,
            },
            {
                contractAddress: '0x79ebc9a2ce02277a4b5b3a768b1c0a4ed75bd936',
                chainId: '56',
                name: 'catgirl',
                marketCap: 656614.9267537371,
            },
            {
                contractAddress: '9cC36bMZCt9fF53eLBQCago1czw5L9GRHZBL5adWEyAu',
                chainId: '1399811149',
                name: 'SofaCat',
                marketCap: 448847.14959719643,
            },
            {
                contractAddress: '0x56015bbe3c01fe05bc30a8a9a9fd9a88917e7db3',
                chainId: '1',
                name: 'Cat Token',
                marketCap: 286684.3789711021,
            },
            {
                contractAddress: '0xdb08CA267e824fb29eb455B7e06Fe73FB0370895',
                chainId: '8453',
                name: 'Godcat Exploding Kittens',
                marketCap: 81508.07952258679,
            },
            {
                contractAddress: 'EavJDLh8cYTAnt3QDitpKGMsPL2hq1My5g9R2P6at6Lc',
                chainId: '1399811149',
                name: 'Catman',
                marketCap: 57500.99665617707,
            },
            {
                contractAddress: '7y3mLy8vai6uMt4iVfgm1gN5GRpQ4aMqtMJgM6oLuoeM',
                chainId: '1399811149',
                name: "Taylor Swift's Cat MEREDITH",
                marketCap: 0,
            },
            {
                contractAddress: '0x102A6625b69b214BD2422952C8A6401a4b800B73',
                chainId: '56',
                name: 'SPACE CAT',
                marketCap: 0,
            },
            {
                contractAddress: '9D1PVa9mJKtXXjDGQW4sRDYQwaJxnWoPSrQEGoFq7Gei',
                chainId: '1399811149',
                name: 'Catgoku',
                marketCap: 0,
            },
            {
                contractAddress: '0x478156DeAbfAc918369044D52A6BdB5Cc5597994',
                chainId: '1',
                name: 'Schrodinger',
                marketCap: 0,
            },
            {
                contractAddress: '0x8A452Daaf59F79fD511484B5Ce9474E32DD189ce',
                chainId: '56',
                name: 'BIC',
                marketCap: 0,
            },
            {
                contractAddress: '0x508e00d5cef397b02d260d035e5ee80775e4c821',
                chainId: '1',
                name: 'Bitcoin Cats',
                marketCap: 0,
            },
            {
                contractAddress: '0xe576670499de7d832f3eb59e07b603c7b5c10a36',
                chainId: '56',
                name: 'BNBcat',
                marketCap: 0,
            },
            {
                contractAddress: '0xFeE3109f0B361dBb2Db8C95a4ae9E6f86CCf7466',
                chainId: '56',
                name: 'Bullying Cat',
                marketCap: null,
            },
            {
                contractAddress: '0x52E6654AEe5d59E13aE30B48F8F5dBeb97F708Cd',
                chainId: '1',
                name: 'Tsutsuji',
                marketCap: 0,
            },
            {
                contractAddress: '0x9e20461bc2c4c980f62f1B279D71734207a6A356',
                chainId: '1',
                name: 'OmniCat',
                marketCap: 0,
            },
            {
                contractAddress: 'G3vWvAaXPHCnncnyAbq6yBRXqfRtEV3h7vExzasZeT6g',
                chainId: '1399811149',
                name: 'CATWIFHAT',
                marketCap: 0,
            },
            {
                contractAddress: '0xae0FE8474CF5b1B412b3E4327A1c535ea12b77b7',
                chainId: '1',
                name: 'MAGA CAT',
                marketCap: 0,
            },
            {
                contractAddress: '8yJ15ee2AUQmwbWPxXLTTeBTzyMGn4MtSRKMqVHw1J1G',
                chainId: '1399811149',
                name: 'Kitty AI',
                marketCap: 0,
            },
            {
                contractAddress: '0x2cf0493eaf67e5dcd65e26b7204e440123252c85',
                chainId: '1',
                name: 'Schrodinger',
                marketCap: 0,
            },
            {
                contractAddress: '0xc94660716C5579fE28deA46Bd3C27624f8581Fd6',
                chainId: '56',
                name: 'Chi Yamada Cat',
                marketCap: null,
            },
            {
                contractAddress: '6vrEZV86doP7VB2uqX4th8KB3dbd2QgcQh56RvEPx713',
                chainId: '1399811149',
                name: 'Catizen on SOL',
                marketCap: 0,
            },
            {
                contractAddress: '0x1BB4aFbF2cE0C9ec86E6414ad4Ba4d9aab1c0De4',
                chainId: '1',
                name: 'TORA NEKO',
                marketCap: 0,
            },
            {
                contractAddress: '3FrSmUQQPjjdcWFWdHdoY974k2ZBwRT673eYFkhgkkWK',
                chainId: '1399811149',
                name: 'TRUMP CAT',
                marketCap: 0,
            },
            {
                contractAddress: '0xED6AF21Df463c7f116A6d7d687A4c190c4cf7586',
                chainId: '56',
                name: 'FU coin',
                marketCap: 0,
            },
            {
                contractAddress: 'FjBSZAeo7NsgUdgXRA63VuGA3ySfVi5yu2bhCfuZgxJY',
                chainId: '1399811149',
                name: 'Lola',
                marketCap: 0,
            },
            {
                contractAddress: '0x814A870726EdB7Dfc4798300ae1ce3E5Da0Ac467',
                chainId: '1',
                name: 'daCat',
                marketCap: 0,
            },
            {
                contractAddress: '29yJ5aNHZEmLFuxzKC75MPpdQbiHCur7pkhdwswJ8Vny',
                chainId: '1399811149',
                name: 'Googly Cat',
                marketCap: null,
            },
            {
                contractAddress: '5wU4tUcAbds7d5cmnGK2otHa9gbayYsD2mhz1reR6c91',
                chainId: '1399811149',
                name: 'Tongue Cat',
                marketCap: 0,
            },
            {
                contractAddress: '0x0dA2082905583cEdFfFd4847879d0F1Cf3d25C36',
                chainId: '1',
                name: 'melo',
                marketCap: 0,
            },
            {
                contractAddress: 'EtQE3GREPyFBCU3yUXc5nWs3wRtLYuMmtKAFAvXD1yuR',
                chainId: '1399811149',
                name: 'SASHA CAT',
                marketCap: 0,
            },
            {
                contractAddress: '2JcXacFwt9mVAwBQ5nZkYwCyXQkRcdsYrDXn6hj22SbP',
                chainId: '1399811149',
                name: 'mini',
                marketCap: 0,
            },
            {
                contractAddress: '0x1ccb4b14a11e0f2994a7ecbbd4cc69632f4c7c76',
                chainId: '8453',
                name: 'Cute Cat Candle',
                marketCap: 0,
            },
            {
                contractAddress: '0x42fa9fbf92852b3f7b0a2816b00357c8541d2b53',
                chainId: '56',
                name: 'Hello Kitty',
                marketCap: null,
            },
            {
                contractAddress: '68gjZJHe645Nb6RTDQiGXKgHXmsKcqLuEVHvies3b4mb',
                chainId: '1399811149',
                name: 'Cat in Gucci',
                marketCap: 0,
            },
            {
                contractAddress: 'HYJVpy2KRkF8L7W5cZmFQbs8HjsLvWQCPbUUSsbptaho',
                chainId: '1399811149',
                name: 'VODKA CAT',
                marketCap: 0,
            },
            {
                contractAddress: '2VYVwrwSNM8WxbFdPU4KQpZUB9FWCenFFoDqvpHQ7rZE',
                chainId: '1399811149',
                name: 'Jail Cat',
                marketCap: 0,
            },
            {
                contractAddress: '0xA47F5646fd7A92595B69000A31a069f6b5c7777c',
                chainId: '56',
                name: 'MOON CAT',
                marketCap: 0,
            },
            {
                contractAddress: '9cbT3yVMt3VhkgwWkU9tSiT9YmCfPzarrSJBrmPiHui3',
                chainId: '1399811149',
                name: 'CatCoin',
                marketCap: 0,
            },
            {
                contractAddress: '0xaaee85310ea1c7136eb1aa436f2a6a963be6e617',
                chainId: '1',
                name: 'JoyCat Coin',
                marketCap: 0,
            },
            {
                contractAddress: '8PMJczfs9W8TDKiNBD85AuqxE8tWACCDeUwxpUeadL3j',
                chainId: '1399811149',
                name: 'CEILING CAT',
                marketCap: 0,
            },
            {
                contractAddress: '0xad96712A6BdFd4123351C6738B2e6dB0Ba28f306',
                chainId: '56',
                name: 'NinjaCat',
                marketCap: 0,
            },
            {
                contractAddress: '0xE4fc328aE212232EFc5F5dd0e0b1537cd055d715',
                chainId: '8453',
                name: 'Giga Cat on Base',
                marketCap: 0,
            },
            {
                contractAddress: '6pcecbkiNAJBNQqbmw7KYfzikrtwzUqmBKusJfKJsuR6',
                chainId: '1399811149',
                name: 'SUPERCAT',
                marketCap: 0,
            },
            {
                contractAddress: 'kit3zVeWba8xxV3DB4oFGsfFfTv8qadvRbbtXihuA3g',
                chainId: '1399811149',
                name: 'Solana Kit',
                marketCap: 0,
            },
            {
                contractAddress: '3dCCbYca3jSgRdDiMEeV5e3YKNzsZAp3ZVfzUsbb4be4',
                chainId: '1399811149',
                name: 'Buttercat',
                marketCap: 0,
            },
            {
                contractAddress: 'Gsq3ke5SQdNiVK8sFcnY39Lu9EyhHmQNGFnmvSy5USn2',
                chainId: '1399811149',
                name: 'catwifhat',
                marketCap: null,
            },
            {
                contractAddress: '0x74d2d73B455540B037298c0e0925BC702AEDbE4a',
                chainId: '1',
                name: 'Schrodinger',
                marketCap: null,
            },
            {
                contractAddress: '0xf0C99B0288508D004F4aBeCa34d830CE7682977C',
                chainId: '56',
                name: 'GameStop Coin',
                marketCap: 0,
            },
            {
                contractAddress: '0x04A969bc8Ed2b2F0b00620575F85B49756855Cf8',
                chainId: '1',
                name: 'TRUMPCAT',
                marketCap: null,
            },
            {
                contractAddress: '3WKzqdh3ZW3tP2PhAtAuDu4e1XsEzFhk7qnN8mApm3S2',
                chainId: '1399811149',
                name: 'CAT (SOL)',
                marketCap: 0,
            },
            {
                contractAddress: '0xdBB910F546De59857194c51BC28f6BDFAA6bc58f',
                chainId: '1',
                name: 'CATECOIN',
                marketCap: null,
            },
            {
                contractAddress: '9ibewRtF2yGBNumg3K3uL2GahsUeQ1zsBjb76Eypump',
                chainId: '1399811149',
                name: 'Onigiri The Cat',
                marketCap: 0,
            },
            {
                contractAddress: 'AB1e1rTGF8xSoYzXEwNWohuMHLCMrBoaSxT6AARmQksd',
                chainId: '1399811149',
                name: 'TwoTalkingCats',
                marketCap: 0,
            },
            {
                contractAddress: 'ELST1oAp3czkRRRWGeTgttGsEqkD2qjDRJXR4Asmkk5y',
                chainId: '1399811149',
                name: 'CHUCHU',
                marketCap: 0,
            },
            {
                contractAddress: '6n7Janary9fqzxKaJVrhL9TG2F61VbAtwUMu1YZscaQS',
                chainId: '1399811149',
                name: "Ansem's Cat",
                marketCap: 0,
            },
            {
                contractAddress: '6PPskLwejGjiRbsrdTvPdo8Ayf6rERxvSezcPDA53TAP',
                chainId: '1399811149',
                name: 'MusCat',
                marketCap: 0,
            },
            {
                contractAddress: 'scatYPdryopAPpriuyn5a4UyPSD9weFP4KCKq9Ykskp',
                chainId: '1399811149',
                name: 'Selfie Cat',
                marketCap: 0,
            },
            {
                contractAddress: '3M2vepByfZTG6xUSmFidvSCFzHWFoVw7cPvyRDnUpump',
                chainId: '1399811149',
                name: 'Kolt',
                marketCap: 0,
            },
            {
                contractAddress: '7dr2iYb1Xq29H13RXW1wHhrAqbYF39SDXAU5nGFTpNmU',
                chainId: '1399811149',
                name: 'Catscoin',
                marketCap: 0,
            },
            {
                contractAddress: '0x4f60c8d585ca9e994750f53a989aa865ec99c9f7',
                chainId: '1',
                name: 'Catcoin',
                marketCap: null,
            },
            {
                contractAddress: '3obNTknsf4hq5pNh3GDPEhyCB9WTKJJzM2PcqfKgLmBu',
                chainId: '1399811149',
                name: 'Cats Of Sol',
                marketCap: 0,
            },
            {
                contractAddress: '0x546d499689e0d4101c7ea774a61e312d1ad72352',
                chainId: '56',
                name: 'Baby Cat',
                marketCap: 0,
            },
            {
                contractAddress: '0x7Df083f3b16a37Ee91E89d4a11D62053AAD331a4',
                chainId: '56',
                name: 'Cat Finance',
                marketCap: 0,
            },
            {
                contractAddress: 'VP9UaBXLM4KYRvyjisu65rz8BU5xNAbewU7LVmyU2x4',
                chainId: '1399811149',
                name: 'Vibing Cat',
                marketCap: 0,
            },
        ],
    },
    {
        id: '60bdcb4acd44627a464e36c5',
        name: 'Doggone Doggerel',
        geniusName: 'Dogs',
        targetFilters: [
            'Ethereum',
            'Optimism',
            'BNB Smart Chain (BEP20)',
            'Polygon',
            'Base',
            'Arbitrum',
            'Avalanche C-Chain',
            'Solana',
        ],
        tokens: [
            {
                contractAddress: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
                chainId: '56',
                name: 'Dogecoin',
                marketCap: 18202188886.21885,
            },
            {
                contractAddress: '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
                chainId: '1',
                name: 'Shiba Inu',
                marketCap: 10866402887.051943,
            },
            {
                contractAddress: 'EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm',
                chainId: '1399811149',
                name: 'dogwifhat',
                marketCap: 2626413689.856528,
            },
            {
                contractAddress: '0x1151CB3d861920e07a38e03eEAd12C32178567F6',
                chainId: '1',
                name: 'Bonk',
                marketCap: 1830604652.3159084,
            },
            {
                contractAddress: '0xcf0c122c6b73ff809c693db761e7baebe62b6a2e',
                chainId: '1',
                name: 'FLOKI',
                marketCap: 1438973459.2336624,
            },
            {
                contractAddress: '0x812ba41e071c7b7fa4ebcfb62df5f45f6fa853ee',
                chainId: '1',
                name: 'First Neiro On Ethereum',
                marketCap: 850076364.8227562,
            },
            {
                contractAddress: 'MEW1gQWJ3nEXg2qgERiKu7FAFj79PHvQVREQUzScPP5',
                chainId: '1399811149',
                name: 'cat in a dogs world',
                marketCap: 752690887.8013334,
            },
            {
                contractAddress: '0xac57de9c1a09fec648e93eb98875b212db0d460b',
                chainId: '1',
                name: 'Baby Doge Coin',
                marketCap: 443391877.0094558,
            },
            {
                contractAddress: '0xa21af1050f7b26e0cff45ee51548254c41ed6b5c',
                chainId: '1',
                name: 'Osaka Protocol',
                marketCap: 244750112.85817522,
            },
            {
                contractAddress: 'HhJpBhRRn4g56VsyLuT8DL5Bv31HkXqsrahTTUCZeZg4',
                chainId: '1399811149',
                name: 'Myro',
                marketCap: 103967133.65478745,
            },
            {
                contractAddress: '0x9813037ee2218799597d83D4a5B6F3b6778218d9',
                chainId: '1',
                name: 'Bone ShibaSwap',
                marketCap: 94108587.20970511,
            },
            {
                contractAddress: '0xee2a03aa6dacf51c18679c516ad5283d8e7c2637',
                chainId: '1',
                name: 'Neiro Ethereum',
                marketCap: 91877407.4522721,
            },
            {
                contractAddress: '0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3',
                chainId: '1',
                name: 'Dogelon Mars',
                marketCap: 78177642.39596918,
            },
            {
                contractAddress: '0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b',
                chainId: '42161',
                name: 'ArbDoge AI',
                marketCap: 68719979.28871648,
            },
            {
                contractAddress: '3B5wuUrMEi5yATD7on46hKfej3pfmd7t1RKgrsN3pump',
                chainId: '1399811149',
                name: 'Billy',
                marketCap: 39625054.50517368,
            },
            {
                contractAddress: '0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D',
                chainId: '1',
                name: 'Kishu Inu',
                marketCap: 30879505.466117043,
            },
            {
                contractAddress: '0x27c70cd1946795b66be9d954418546998b546634',
                chainId: '1',
                name: 'Doge Killer',
                marketCap: 29461370.916493703,
            },
            {
                contractAddress: '7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU',
                chainId: '1399811149',
                name: 'Samoyedcoin',
                marketCap: 27172528.087832496,
            },
            {
                contractAddress: '0xdE342A3E269056fc3305f9e315F4C40D917BA521',
                chainId: '1',
                name: 'Byte',
                marketCap: 17695724.62327541,
            },
            {
                contractAddress: '0x7f792db54b0e580cdc755178443f0430cf799aca',
                chainId: '1',
                name: 'Volt Inu',
                marketCap: 15383189.447349507,
            },
            {
                contractAddress: '0xbb2826ab03b6321e170f0558804f2b6488c98775',
                chainId: '56',
                name: 'Baby Bonk',
                marketCap: 13215351.835224994,
            },
            {
                contractAddress: '0xc11158c5dA9db1D553ED28f0C2BA1CbEDD42CFcb',
                chainId: '1',
                name: 'PAW',
                marketCap: 12044296.513484536,
            },
            {
                contractAddress: '0x7B4328c127B85369D9f82ca0503B000D09CF9180',
                chainId: '1',
                name: 'Dogechain',
                marketCap: 10471573.725007918,
            },
            {
                contractAddress: '0xAFCdd4f666c84Fed1d8BD825aA762e3714F652c9',
                chainId: '1',
                name: 'Vita Inu',
                marketCap: 10022118.282738645,
            },
            {
                contractAddress: 'GYKmdfcUmZVrqfcH1g579BGjuzSRijj3LBuwv79rpump',
                chainId: '1399811149',
                name: 'Wrapped Dog',
                marketCap: 9653762.170008153,
            },
            {
                contractAddress: '0x3301ee63fb29f863f2333bd4466acb46cd8323e6',
                chainId: '1',
                name: 'Akita Inu',
                marketCap: 7606695.918030397,
            },
            {
                contractAddress: '0x7ae5709c585ccfb3e61ff312ec632c21a5f03f70',
                chainId: '56',
                name: 'Doge Dash',
                marketCap: null,
            },
            {
                contractAddress: '0x184ff13B3EBCB25Be44e860163A5D8391Dd568c1',
                chainId: '43114',
                name: 'Kimbo',
                marketCap: 6503898.7556759035,
            },
            {
                contractAddress: '0x243cacb4d5ff6814ad668c3e225246efa886ad5a',
                chainId: '1',
                name: 'Shina Inu',
                marketCap: 6485879.40194284,
            },
            {
                contractAddress: 'CTJf74cTo3cw8acFP1YXF3QpsQUUBGBjh2k2e8xsZ6UL',
                chainId: '1399811149',
                name: 'Neiro (neiro.lol)',
                marketCap: 5022262.901372867,
            },
            {
                contractAddress: '0xae2df9f730c54400934c06a17462c41c08a06ed8',
                chainId: '56',
                name: 'DogeBonk',
                marketCap: 4427232.431536519,
            },
            {
                contractAddress: '0x6adb2e268de2aa1abf6578e4a8119b960e02928f',
                chainId: '1',
                name: 'ShibaDoge',
                marketCap: 3252702.1912402646,
            },
            {
                contractAddress: 'E6AujzX54E1ZoPDFP2CyG3HHUVKygEkp6DRqig61pump',
                chainId: '1399811149',
                name: 'Pochita',
                marketCap: 2560270.5909940177,
            },
            {
                contractAddress: '2XPqoKfJitk8YcMDGBKy7CMzRRyF2X9PniZeCykDUZev',
                chainId: '1399811149',
                name: 'HUND',
                marketCap: 2277526.122464462,
            },
            {
                contractAddress: '3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc',
                chainId: '1399811149',
                name: 'Cheems',
                marketCap: 2286822.9893203927,
            },
            {
                contractAddress: '0x6969f3a3754ab674b48b7829a8572360e98132ba',
                chainId: '1',
                name: 'Izzy',
                marketCap: 1922763.5034258314,
            },
            {
                contractAddress: 'HJ39rRZ6ys22KdB3USxDgNsL7RKiQmsC3yL8AS3Suuku',
                chainId: '1399811149',
                name: "What's Updog",
                marketCap: 1554318.5582504824,
            },
            {
                contractAddress: '0xc9Ad37E9Baf41377540Df5a77831Db98c1915128',
                chainId: '56',
                name: 'Green Shiba Inu [New]',
                marketCap: 1147493.5987576207,
            },
            {
                contractAddress: '0x49324d59327fB799813B902dB55b2a118d601547',
                chainId: '56',
                name: 'Boss Token',
                marketCap: 1121480.6188973556,
            },
            {
                contractAddress: '0x74926b3d118a63f6958922d3dc05eb9c6e6e00c6',
                chainId: '56',
                name: 'DOGGY',
                marketCap: 917169.2470890747,
            },
            {
                contractAddress: '0xbb1ee07d6c7baeb702949904080eb61f5d5e7732',
                chainId: '1',
                name: 'Dogey-Inu',
                marketCap: null,
            },
            {
                contractAddress: '9nEqaUcb16sQ3Tn1psbkWqyhPdLmfHWjKGymREjsAgTE',
                chainId: '1399811149',
                name: 'WOOF',
                marketCap: 671066.3830909278,
            },
            {
                contractAddress: '0x1001271083C249bd771E1bb76C22D935809a61Ee',
                chainId: '1',
                name: 'Fuku-Kun',
                marketCap: 560029.3385069154,
            },
            {
                contractAddress: '0x2C5BC2Ba3614fD27FCc7022eA71d9172E2632c16',
                chainId: '1',
                name: 'Shib Original Vision',
                marketCap: 442616.11227355216,
            },
            {
                contractAddress: '0x9b9087756eca997c5d595c840263001c9a26646d',
                chainId: '1',
                name: 'DOGEFI',
                marketCap: null,
            },
            {
                contractAddress: '0x440aBbf18c54b2782A4917b80a1746d3A2c2Cce1',
                chainId: '43114',
                name: 'SHIBAVAX',
                marketCap: null,
            },
            {
                contractAddress: '0xf48f91df403976060cC05dBbf8A0901b09fdeFd4',
                chainId: '56',
                name: 'Minu',
                marketCap: 224961.5421492448,
            },
            {
                contractAddress: '0x15ee3f09712f4715904e1923c1ad504a673e88ac',
                chainId: '1',
                name: 'Nvidia Inu',
                marketCap: 175202.25991932137,
            },
            {
                contractAddress: '0x1cfd6813a59d7b90c41dd5990ed99c3bf2eb8f55',
                chainId: '56',
                name: 'The Corgi of PolkaBridge',
                marketCap: 75673.22084009091,
            },
            {
                contractAddress: 'GWGaL7XrSCcVjKU2FwYoBgqPnEmUkxsmNBoVmDC6BhkA',
                chainId: '1399811149',
                name: 'Dogy',
                marketCap: 55623.779862275056,
            },
            {
                contractAddress: 'SAMUmmSvrE8yqtcG94oyP1Zu2P9t8PSRSV3vewsGtPM',
                chainId: '1399811149',
                name: 'Samusky',
                marketCap: null,
            },
            {
                contractAddress: '0xf8e9f10c22840b613cda05a0c5fdb59a4d6cd7ef',
                chainId: '1',
                name: 'Dogs Of Elon',
                marketCap: null,
            },
            {
                contractAddress: '0x43d7e65b8ff49698d9550a7f315c87e67344fb59',
                chainId: '1',
                name: 'Shiba Saga',
                marketCap: 19266.017631960625,
            },
            {
                contractAddress: '0xB68A34756D8A92CCc821EFfA03d802846594b64E',
                chainId: '56',
                name: 'ClassicDoge',
                marketCap: null,
            },
            {
                contractAddress: '0xb4fbed161bebcb37afb1cb4a6f7ca18b977ccb25',
                chainId: '1',
                name: 'Dogeswap',
                marketCap: 14561.624461491683,
            },
            {
                contractAddress: '0x8aa9381b2544b48c26f3b850F6e07E2c5161EB3e',
                chainId: '1',
                name: 'Wrapped Dogecoin',
                marketCap: 9028.069234989107,
            },
            {
                contractAddress: '0x45289007706E7Ee7B42b1fA506661d97740Edfb4',
                chainId: '56',
                name: 'FLOKI CEO',
                marketCap: 0,
            },
            {
                contractAddress: '0xDDA5d6B9Cc5766f377375c41fdB2d41703f4dAAd',
                chainId: '56',
                name: 'Twitter Doge',
                marketCap: null,
            },
            {
                contractAddress: '0xA11ff9976018Fda2a8c4ccfa6fFBe8423c5aB668',
                chainId: '56',
                name: 'Floki Cash',
                marketCap: 0,
            },
            {
                contractAddress: '0x14041Dd9e3d3f284DC015e73383100E3D76600F4',
                chainId: '56',
                name: 'BNB BONK',
                marketCap: 0,
            },
            {
                contractAddress: '0xFA296FcA3c7DBa4a92A42Ec0B5E2138DA3b29050',
                chainId: '42161',
                name: 'AiShiba',
                marketCap: 0,
            },
            {
                contractAddress: '0xF1A82bfA7fCEb8B8741e7E04a6B8EfD348cA6393',
                chainId: '42161',
                name: 'ARBSHIB',
                marketCap: 0,
            },
            // {
            //   contractAddress: '0x246fcdc18bf3781b4c5100b3a6decef8dbcc8a31',
            //   chainId: '1',
            //   name: 'AI DogeX',
            //   marketCap: null,
            // },
            {
                contractAddress: '0x9783b81438c24848f85848f8df31845097341771',
                chainId: '1',
                name: 'Dog Collar',
                marketCap: null,
            },
            {
                contractAddress: '0xC40AF1E4fEcFA05Ce6BAb79DcD8B373d2E436c4E',
                chainId: '1',
                name: 'Hokkaidu Inu',
                marketCap: 0,
            },
            {
                contractAddress: '0x2eCd1fdd73158566A78978bEFc33501826262760',
                chainId: '56',
                name: 'Doge Inu',
                marketCap: null,
            },
            {
                contractAddress: '0x764bfc309090e7f93edce53e5befa374cdcb7b8e',
                chainId: '42161',
                name: 'Grimace',
                marketCap: 0,
            },
            {
                contractAddress: '0xaa357b0f167923efc1d6978a868f81866ca6e98c',
                chainId: '56',
                name: 'ShibX',
                marketCap: null,
            },
            {
                contractAddress: '0xcb19633b629C5b7E316096FA465B4F86250DBB55',
                chainId: '1',
                name: 'Trump Shiba',
                marketCap: 0,
            },
            {
                contractAddress: '0xf10b8b6dC146616b86e14eb811e49A7cc64dFd5A',
                chainId: '1',
                name: 'Marshall Inu',
                marketCap: null,
            },
            {
                contractAddress: '0x84a238aa527181f2354a40e9a1c4c3eb4a01bb8a',
                chainId: '56',
                name: 'Liza Coin',
                marketCap: 0,
            },
            {
                contractAddress: '5MBBsoCVddAuF8XixvCcXNbHAw6WfpZ8WyTKMmczxxRN',
                chainId: '1399811149',
                name: 'ShibaInu On Solana',
                marketCap: 0,
            },
            {
                contractAddress: '0x6d6b11219a15aefc32a430ac7ad6429ad36748c9',
                chainId: '1',
                name: 'Shuggi',
                marketCap: null,
            },
            {
                contractAddress: '0xbd4a49e1a0bd8d17faa881d057b48bc18b983e51',
                chainId: '56',
                name: 'DogeBull',
                marketCap: null,
            },
            {
                contractAddress: '0xEc3D04C82aF8C4b97Ecd058D543c2c0673ca72dC',
                chainId: '56',
                name: 'BABY DOGE MONEY MAKER',
                marketCap: null,
            },
            {
                contractAddress: '0x835678028D6d0ad91AE7BB13aA5458D187304589',
                chainId: '56',
                name: 'Lassie Inu',
                marketCap: null,
            },
            {
                contractAddress: '0xa0243CF95800A2f1358CaC08e6367c5aEF6bAB40',
                chainId: '56',
                name: 'BOOK OF DOGE MEMES',
                marketCap: 0,
            },
            // {
            //   contractAddress: '0xa0f446f4754ce940588693ca91a67f16ca5aeafc',
            //   chainId: '1',
            //   name: 'Babadoge',
            //   marketCap: null,
            // },
            {
                contractAddress: '0x2b7d7825A3C57229C07910408D1356eF64407827',
                chainId: '1',
                name: 'Organic Inu',
                marketCap: null,
            },
            {
                contractAddress: '0x259fba5ae8b626483e1e589e8d60a5413a2157d2',
                chainId: '1',
                name: 'Floki Pup',
                marketCap: null,
            },
            {
                contractAddress: '0x1649bf0b3e94452ff1c9d15998e17b645157cb89',
                chainId: '56',
                name: 'DataDoge',
                marketCap: null,
            },
            {
                contractAddress: '0x9ce68CE31c2Cd849d345f3E7534e57F9A1dfe9F8',
                chainId: '56',
                name: 'SibaInu',
                marketCap: null,
            },
            {
                contractAddress: '0xde7a416ac821c77478340eebaa21b68297025ef3',
                chainId: '8453',
                name: 'Beni',
                marketCap: 0,
            },
            {
                contractAddress: '0x29B5F207Ed7Ff7D8DA8a5b1FfaE30D8DC91Be46f',
                chainId: '1',
                name: 'Shih Tzu',
                marketCap: null,
            },
            {
                contractAddress: '0xEf553B6914DBD17567393f7e55fbd773FFf7D0Cb',
                chainId: '8453',
                name: 'Boge',
                marketCap: 0,
            },
            {
                contractAddress: '0x40fa6cc54b5843fe78996f499ec55d05557340c3',
                chainId: '56',
                name: 'Floki SafeMoon',
                marketCap: 0,
            },
            {
                contractAddress: '0x8De5f00225728d4872FA903Fa3DC9AB4C2241eAC',
                chainId: '56',
                name: 'World War Doge',
                marketCap: null,
            },
            {
                contractAddress: '0xac5bf342763248702f4fbd6dc068381a609543a2',
                chainId: '1',
                name: 'KOKA INU',
                marketCap: null,
            },
            {
                contractAddress: '0x090152A527a9f762d820A27Fe9F353718D4132C8',
                chainId: '56',
                name: 'Book of Doge',
                marketCap: null,
            },
            {
                contractAddress: '0x85D19fb57CA7DA715695FCf347CA2169144523a7',
                chainId: '1',
                name: 'Conan',
                marketCap: 0,
            },
        ],
    },
];
